'use client';

import { useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function RecaptchaWrapper({children, deferUntilInteraction = false}) {
    const reCaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA;
    const [isActive, setIsActive] = useState(!deferUntilInteraction);
    const activate = () => {
        setIsActive(true);
    };

    const content = isActive
        ? <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>{children}</GoogleReCaptchaProvider>
        : children;

    // reCAPTCHA stays available regardless of analytics consent.
    return <div
        style={{display: "contents"}}
        onFocusCapture={activate}
        onMouseEnter={activate}
        onPointerDownCapture={activate}
        onTouchStartCapture={activate}
    >
        {content}
    </div>
}